<script lang="ts" setup>
import BaseCard from "@/components/BaseCard.vue";
import BaseCheckbox from "@/components/BaseCheckbox.vue";
import DokkanSupportMemoryList from "@/components/DokkanSupportMemoryList.vue";
import { reactive } from "vue";

const props = defineProps<{
  supportMemories: SupportMemory[];
}>();

const filters = reactive({
  entireBattle: false,
});
</script>

<template>
  <BaseCard v-if="supportMemories.length > 0" class="!p-0">
    <template #heading>Applicable Support Memories</template>

    <div
      class="flex w-full place-content-end gap-2 border-b border-green-900/75 p-4"
    >
      <BaseCheckbox v-model:checked="filters.entireBattle">
        Lasts Entire Battle
      </BaseCheckbox>
    </div>

    <DokkanSupportMemoryList
      :lasts-entire-battle="filters.entireBattle"
      :support-memories="supportMemories"
      class="p-4 pt-0 xl:grid-cols-2"
      with-descriptions
    />
  </BaseCard>
</template>

<style scoped></style>
